import React, { useContext, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ForgotContext } from '../../contexts/ForgotContext';
import { FORGOT_ACTIONS } from './ForgotConstants';
import User from '../../models/User';
import Error from '../../utils/Error';
import { RegisterContext } from '../../contexts/RegisterContext';

const { NEXT_STEP } = FORGOT_ACTIONS;

export const ForgotStep1: React.FC = () => {
	const { t } = useTranslation();
	const { phone, setPhone } = useContext(RegisterContext);
	const { dispatch, setLoading } = useContext(ForgotContext);
	const [errorMessage, setErrorMessage] = useState(null);

	const verifyPhone = useCallback(
		async (e) => {
			e.preventDefault();

			setLoading(true);

			const response = await User.resetPasswordVerifyPhone(phone);

			if (response.isSuccess()) {
				setErrorMessage(null);
				setLoading(false);

				dispatch({ type: NEXT_STEP });
			} else {
				setErrorMessage(Error.getErrorMessage(response.getErrorCode()));
				setLoading(false);
				setPhone(null);
			}
		},
		[dispatch, phone, setLoading, setPhone]
	);

	const onPhoneChange = useCallback((e) => setPhone(e.target.value.trim()), [setPhone]);

	return (
		<form className={'forgot-password-form-step-1 form-large'} onSubmit={verifyPhone}>
			<div className={'message'}>{t('Forgot.Step1.Message')}</div>
			{errorMessage && <div className={'alert alert-danger'}>{errorMessage}</div>}
			<div className={'form-group'}>
				<label htmlFor={'forgot-step1-phone'}>{t('Forgot.Step1.Phone')}</label>
				<input id={'forgot-step1-phone'} autoFocus type={'phone'} autoCapitalize={'false'} autoCorrect={'false'} className={'form-control'} value={phone || ''} onChange={onPhoneChange} />
			</div>
			<div className={'form-buttons'}>
				<input type={'submit'} className={'btn btn-primary'} value={String(t('Forgot.Step1.Submit'))} />
			</div>
		</form>
	);
};
